import type { MessageChanges } from "../core/client.js";
import type { Message } from "../core/types.js";
import { normalizeReactions } from "../components/message/reactions/reactions.js";

// CYBORG-1210: apply a change-feed answer to rows already on screen. Every field the 0225
// trigger stamps is copied; rows the pane does not hold are ignored (the drain brings them).
export function applyMessageChanges(messages: Message[], res: MessageChanges): Message[] {
  const upserts = new Map(res.upserts.map((m) => [m.id, m]));
  const gone = new Set(res.tombstones.map((t) => t.id));
  if (upserts.size === 0 && gone.size === 0) return messages;
  const out: Message[] = [];
  for (const m of messages) {
    if (m.parentId && gone.has(m.parentId)) continue;
    if (gone.has(m.id)) {
      out.push(Object.assign({}, m, { deleted: true, text: "", reactions: undefined }));
      continue;
    }
    const fresh = upserts.get(m.id);
    out.push(
      fresh
        ? {
            ...m,
            text: fresh.text,
            updatedAt: fresh.updatedAt,
            reactions: normalizeReactions(fresh.reactions),
            pinnedAt: fresh.pinnedAt,
            pinnedBy: fresh.pinnedBy,
            unfurls: fresh.unfurls,
            card: fresh.card,
            attachments: fresh.attachments,
          }
        : m,
    );
  }
  return out;
}
